module.exports = __webpack_public_path__ + "img/topicMedicalServices.0aaa0036.svg";